import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';
import { useFetchHotelStatic } from './useFetchHotelStatic';

// Stable empty result so callers can depend on the reference without re-rendering on every tick.
const NO_CERTIFICATIONS: SustainabilityCertification[] = [];

/**
 * Third-party sustainability certifications held by the property, shown next to the CO2 estimate.
 * Behind its own flag, off by default, on top of the market flag that governs the rest of the
 * sustainability content: a market with sustainability off never renders certifications either.
 */
export function useSustainabilityCertifications(): SustainabilityCertification[] {
  const { sustainabilityEnabled, sustainabilityCertificationsEnabled } =
    usePageWrapperData().localization.configValuesApp;
  const { data: hotelStaticData } = useFetchHotelStatic();

  if (!sustainabilityEnabled || !sustainabilityCertificationsEnabled) return NO_CERTIFICATIONS;

  return hotelStaticData?.sustainabilityCertifications ?? NO_CERTIFICATIONS;
}
